import _ from 'lodash';
import {
  CAL_DELETE_EVENT,
  CAL_GET_CAL_BAYS,
  CAL_GET_CAL_CONFIG,
  CAL_GET_CUSTINFO,
  CAL_GET_EVENTS,
  CAL_GET_GROUPS,
  CAL_GET_GROUP_CATEGORIES,
  CAL_GET_GROUP_CATEGORY,
  CAL_GET_GROUP_USERS,
  CAL_GET_SS_CODES,
  CAL_GET_TEMPLATES,
  CAL_GET_USERS,
  CAL_SET_EVENT,
} from '../actions/CalendarActions';

const INITIAL_STATE = {
  users: [],
  events: [],
  calConfig: {},
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case CAL_GET_CAL_CONFIG:
      return { ...state, calConfig: action.payload.data };

    case CAL_GET_CAL_BAYS:
      return { ...state, bays: action.payload.data };

    case CAL_GET_CUSTINFO:
      return { ...state, custInfo: action.payload.data };

    case CAL_GET_EVENTS:
      return { ...state, events: _.unionWith(action.payload.data || [], state.events, (e1, e2) => e1.id === e2.id) };

    case CAL_GET_GROUPS:
      return { ...state, groups: action.payload.data };

    case CAL_GET_USERS:
      return { ...state, users: action.payload.data };

    case CAL_GET_GROUP_USERS:
      return { ...state, groupUsers: action.payload.data };

    case CAL_GET_GROUP_CATEGORIES:
      return { ...state, groupCategories: action.payload.data };

    case CAL_GET_SS_CODES:
      return { ...state, shopStatusCodes: action.payload.data };

    case CAL_GET_GROUP_CATEGORY:
      return { ...state, groupCategory: action.payload.data };

    case CAL_GET_TEMPLATES:
      return { ...state, templates: action.payload.data };

    case CAL_SET_EVENT:
      return { ...state, saveEvent: action.payload.data };

    case CAL_DELETE_EVENT:
      const events = state.events.filter(e => e.id !== _.get(action, 'payload.data.id'));
      return { ...state, events };

    default:
      return state;
  }
}
